import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import Icon from 'components/atoms/Icon';
import UIAsset from 'components/atoms/UIAsset';
import LoginButton from 'containers/molecules/LoginButton';

import { routes } from 'defs';
import i18n from 'helper/i18n';
import mapBackendConfig from 'helper/mapBackendConfig';

export type UserDataType = {
	firstName?: string;
	lastName?: string;
};

export type HeaderServiceProps = {
	userData?: UserDataType;
	hasAuthenticationLoaded: boolean;
};

class HeaderService extends React.Component<HeaderServiceProps> {
	public static displayName = 'HeaderService';

	get userName(): string {
		const { userData } = this.props;
		if (!userData || !userData.firstName || !userData.lastName) {
			return '';
		}
		return `${userData.firstName} ${userData.lastName}`;
	}

	public render() {
		const { userData } = this.props;
		return (
			<ol className="o-header-service">
				<li className="o-header-service__item">
					<a
						className="o-header-service__link o-header-service__link--impuls"
						href={mapBackendConfig.env.migrosImpulsURL}
					>
						<Icon iconName="arrow-left" />
						<span> {i18n('react.impulsCoach.components.HeaderService.toImpuls')}</span>
					</a>
				</li>
				<li className="o-header-service__item">
					{/* eslint-disable-next-line */}
					<a className="o-header-service__link" href="https://www.migros.ch" target="_blank">
						<UIAsset src="/img/svg/migros-small-logo.svg" alt="" />
					</a>
				</li>
				<li className="o-header-service__item">
					<a
						className="o-header-service__link o-header-service__link--newsletter"
						href={mapBackendConfig.env.migrosImpulsNewsletterPage.href}
					>
						<span>{i18n('react.impulsCoach.components.HeaderService.newsletter')}</span>
					</a>
				</li>
				{userData && (
					<li className="o-header-service__item">
						<RouterLink
							to={routes.profile.indexRoute.href}
							className="o-header-service__link o-header-service__link--user"
						>
							<Icon iconName="user" />
							<span className="o-header-service__profile">
								{i18n('react.impulsCoach.components.HeaderService.myProfile')} {this.userName}
							</span>
						</RouterLink>
					</li>
				)}
				<li className="o-header-service__item">
					<LoginButton />
				</li>
			</ol>
		);
	}
}

export { HeaderService };
export default HeaderService;
